export default __webpack_public_path__ + "static/media/profile.bfdfdf0b.png";